import { Injectable } from '@angular/core';
import { AppConfig } from '../../app/app.config';
import { DbContext, DbTable } from '../data/dbcontext.service';
import { LocationOption, SetupChangeLogRecord } from '../../models/setup/setup.models';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';
import { TimeZoneService } from '../time-zone/time-zone.service';

@Injectable()
export class SetupDataService {
  config = AppConfig.settings;
  private readonly setupChangeLogTable: DbTable;

  constructor(private dbContext: DbContext,
              private dateParserService: DateParserService,
              private timeZoneService: TimeZoneService) {
    this.setupChangeLogTable = this.dbContext.tables.find(t => t.name === 'SetupChangeLogData');
  }

  async getSetupChangeLogData(): Promise<SetupChangeLogRecord[]> {
    let data = await this.dbContext.getAll(this.setupChangeLogTable) as SetupChangeLogRecord[];

    data = data.filter(e => e.timeOfChange && e.timeOfChange.dateTime);

    for (let i = 0; i < data.length; i++) {
      data[i] = await this.deserializeSetupChangeLogRecord(data[i]);
      data[i].selectedLocation = {
        id: data[i].newValueId,
        name: data[i].newValue
      };
    }

    return data;
  }

  async deserializeSetupChangeLogRecord(setupChangeLogRecord: SetupChangeLogRecord): Promise<SetupChangeLogRecord> {
    if (setupChangeLogRecord.timeOfChange) {
      setupChangeLogRecord.timeOfChange = await this.dateParserService.deserializePtLuxonDate(setupChangeLogRecord.timeOfChange, this.timeZoneService);
    }

    return setupChangeLogRecord;
  }
}



// WEBPACK FOOTER //
// ./src/services/setup/setup-data.service.ts